import React, { FC, HTMLAttributes } from 'react'

export const customStrongFormatter = (props?: React.DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>): FC => (...chunks) => (
    <strong {...props}>{chunks}</strong>
)
